module.exports = __webpack_public_path__ + "static/media/photo208.cd716954.jpg";